import React, { useRef, useEffect } from 'react';

const C = {
  keyword: '#c678dd',
  func: '#61afef',
  string: '#98c379',
  number: '#d19a66',
  comment: '#5c6370',
  variable: '#e06c75',
  operator: '#56b6c2',
  plain: '#abb2bf',
  bracket: '#e5c07b',
};

const codeBlocks = [
  [{ t:'keyword',v:'async '},{t:'func',v:'analyzeMarket'},{t:'bracket',v:'('},{t:'variable',v:'ticker'},{t:'plain',v:': '},{t:'func',v:'string'},{t:'bracket',v:')'},{t:'plain',v:' {'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'const '},{t:'variable',v:'data'},{t:'operator',v:' = '},{t:'keyword',v:'await '},{t:'func',v:'fetchOHLC'},{t:'bracket',v:'('},{t:'variable',v:'ticker'},{t:'plain',v:', '},{t:'string',v:"'1d'"},{t:'bracket',v:')'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'const '},{t:'variable',v:'rsi'},{t:'operator',v:' = '},{t:'func',v:'calcRSI'},{t:'bracket',v:'('},{t:'variable',v:'data'},{t:'plain',v:', '},{t:'number',v:'14'},{t:'bracket',v:')'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'const '},{t:'variable',v:'macd'},{t:'operator',v:' = '},{t:'func',v:'calcMACD'},{t:'bracket',v:'('},{t:'variable',v:'data'},{t:'plain',v:', '},{t:'number',v:'12'},{t:'plain',v:', '},{t:'number',v:'26'},{t:'plain',v:', '},{t:'number',v:'9'},{t:'bracket',v:')'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'const '},{t:'variable',v:'signal'},{t:'operator',v:' = '},{t:'func',v:'neuralPredict'},{t:'bracket',v:'('},{t:'bracket',v:'{'},{t:'variable',v:'rsi'},{t:'plain',v:', '},{t:'variable',v:'macd'},{t:'plain',v:', '},{t:'variable',v:'volume'},{t:'bracket',v:'}'},{t:'bracket',v:')'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'if '},{t:'bracket',v:'('},{t:'variable',v:'signal'},{t:'plain',v:'.'},{t:'variable',v:'confidence'},{t:'operator',v:' > '},{t:'number',v:'0.85'},{t:'bracket',v:')'},{t:'plain',v:' {'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'return '},{t:'func',v:'execute'},{t:'bracket',v:'('},{t:'variable',v:'signal'},{t:'plain',v:'.'},{t:'variable',v:'action'},{t:'plain',v:', '},{t:'variable',v:'ticker'},{t:'bracket',v:')'}],
  [{t:'plain',v:'  }'}],
  [{t:'plain',v:'}'}],
  [],
  [{t:'comment',v:'// Risk management module'}],
  [{t:'keyword',v:'function '},{t:'func',v:'calcPositionSize'},{t:'bracket',v:'('},{t:'variable',v:'balance'},{t:'plain',v:', '},{t:'variable',v:'risk'},{t:'bracket',v:')'},{t:'plain',v:' {'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'const '},{t:'variable',v:'maxLoss'},{t:'operator',v:' = '},{t:'variable',v:'balance'},{t:'operator',v:' * '},{t:'variable',v:'risk'},{t:'operator',v:' * '},{t:'number',v:'0.02'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'const '},{t:'variable',v:'atr'},{t:'operator',v:' = '},{t:'func',v:'calcATR'},{t:'bracket',v:'('},{t:'number',v:'14'},{t:'bracket',v:')'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'return '},{t:'func',v:'Math.floor'},{t:'bracket',v:'('},{t:'variable',v:'maxLoss'},{t:'operator',v:' / '},{t:'variable',v:'atr'},{t:'bracket',v:')'}],
  [{t:'plain',v:'}'}],
  [],
  [{t:'comment',v:'// Backtest engine'}],
  [{t:'keyword',v:'class '},{t:'func',v:'BacktestEngine'},{t:'plain',v:' {'}],
  [{t:'plain',v:'  '},{t:'func',v:'constructor'},{t:'bracket',v:'('},{t:'variable',v:'strategy'},{t:'plain',v:', '},{t:'variable',v:'capital'},{t:'bracket',v:')'},{t:'plain',v:' {'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'this'},{t:'plain',v:'.'},{t:'variable',v:'strategy'},{t:'operator',v:' = '},{t:'variable',v:'strategy'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'this'},{t:'plain',v:'.'},{t:'variable',v:'capital'},{t:'operator',v:' = '},{t:'variable',v:'capital'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'this'},{t:'plain',v:'.'},{t:'variable',v:'trades'},{t:'operator',v:' = '},{t:'bracket',v:'[]'}],
  [{t:'plain',v:'  }'}],
  [],
  [{t:'plain',v:'  '},{t:'keyword',v:'async '},{t:'func',v:'run'},{t:'bracket',v:'('},{t:'variable',v:'startDate'},{t:'plain',v:', '},{t:'variable',v:'endDate'},{t:'bracket',v:')'},{t:'plain',v:' {'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'const '},{t:'variable',v:'bars'},{t:'operator',v:' = '},{t:'keyword',v:'await '},{t:'func',v:'loadHistorical'},{t:'bracket',v:'('},{t:'variable',v:'startDate'},{t:'plain',v:', '},{t:'variable',v:'endDate'},{t:'bracket',v:')'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'for '},{t:'bracket',v:'('},{t:'keyword',v:'const '},{t:'variable',v:'bar'},{t:'keyword',v:' of '},{t:'variable',v:'bars'},{t:'bracket',v:')'},{t:'plain',v:' {'}],
  [{t:'plain',v:'      '},{t:'keyword',v:'const '},{t:'variable',v:'action'},{t:'operator',v:' = '},{t:'keyword',v:'this'},{t:'plain',v:'.'},{t:'variable',v:'strategy'},{t:'plain',v:'.'},{t:'func',v:'evaluate'},{t:'bracket',v:'('},{t:'variable',v:'bar'},{t:'bracket',v:')'}],
  [{t:'plain',v:'      '},{t:'keyword',v:'if '},{t:'bracket',v:'('},{t:'variable',v:'action'},{t:'bracket',v:')'},{t:'plain',v:' '},{t:'keyword',v:'this'},{t:'plain',v:'.'},{t:'func',v:'executeTrade'},{t:'bracket',v:'('},{t:'variable',v:'action'},{t:'plain',v:', '},{t:'variable',v:'bar'},{t:'bracket',v:')'}],
  [{t:'plain',v:'    }'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'return '},{t:'keyword',v:'this'},{t:'plain',v:'.'},{t:'func',v:'getResults'},{t:'bracket',v:'()'}],
  [{t:'plain',v:'  }'}],
  [],
  [{t:'plain',v:'  '},{t:'func',v:'getResults'},{t:'bracket',v:'()'},{t:'plain',v:' {'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'const '},{t:'variable',v:'pnl'},{t:'operator',v:' = '},{t:'keyword',v:'this'},{t:'plain',v:'.'},{t:'variable',v:'trades'},{t:'plain',v:'.'},{t:'func',v:'reduce'},{t:'bracket',v:'('},{t:'bracket',v:'('},{t:'variable',v:'s'},{t:'plain',v:', '},{t:'variable',v:'t'},{t:'bracket',v:')'},{t:'operator',v:' => '},{t:'variable',v:'s'},{t:'operator',v:' + '},{t:'variable',v:'t'},{t:'plain',v:'.'},{t:'variable',v:'pnl'},{t:'plain',v:', '},{t:'number',v:'0'},{t:'bracket',v:')'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'const '},{t:'variable',v:'winRate'},{t:'operator',v:' = '},{t:'keyword',v:'this'},{t:'plain',v:'.'},{t:'variable',v:'trades'},{t:'plain',v:'.'},{t:'func',v:'filter'},{t:'bracket',v:'('},{t:'variable',v:'t'},{t:'operator',v:' => '},{t:'variable',v:'t'},{t:'plain',v:'.'},{t:'variable',v:'pnl'},{t:'operator',v:' > '},{t:'number',v:'0'},{t:'bracket',v:')'},{t:'plain',v:'.'},{t:'variable',v:'length'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'const '},{t:'variable',v:'sharpe'},{t:'operator',v:' = '},{t:'func',v:'calcSharpe'},{t:'bracket',v:'('},{t:'keyword',v:'this'},{t:'plain',v:'.'},{t:'variable',v:'trades'},{t:'bracket',v:')'}],
  [{t:'plain',v:'    '},{t:'keyword',v:'return '},{t:'bracket',v:'{ '},{t:'variable',v:'pnl'},{t:'plain',v:', '},{t:'variable',v:'winRate'},{t:'plain',v:', '},{t:'variable',v:'sharpe'},{t:'plain',v:', '},{t:'variable',v:'trades'},{t:'plain',v:': '},{t:'keyword',v:'this'},{t:'plain',v:'.'},{t:'variable',v:'trades'},{t:'bracket',v:' }'}],
  [{t:'plain',v:'  }'}],
  [{t:'plain',v:'}'}],
  [],
  [{t:'comment',v:'// Neural network layer definitions'}],
  [{t:'keyword',v:'const '},{t:'variable',v:'model'},{t:'operator',v:' = '},{t:'func',v:'Sequential'},{t:'bracket',v:'(['}],
  [{t:'plain',v:'  '},{t:'func',v:'Dense'},{t:'bracket',v:'('},{t:'number',v:'128'},{t:'plain',v:', '},{t:'bracket',v:'{ '},{t:'variable',v:'activation'},{t:'plain',v:': '},{t:'string',v:"'relu'"},{t:'plain',v:', '},{t:'variable',v:'input'},{t:'plain',v:': '},{t:'number',v:'42'},{t:'bracket',v:' }'},{t:'bracket',v:'),'}],
  [{t:'plain',v:'  '},{t:'func',v:'Dropout'},{t:'bracket',v:'('},{t:'number',v:'0.3'},{t:'bracket',v:'),'}],
  [{t:'plain',v:'  '},{t:'func',v:'LSTM'},{t:'bracket',v:'('},{t:'number',v:'64'},{t:'plain',v:', '},{t:'bracket',v:'{ '},{t:'variable',v:'returnSeq'},{t:'plain',v:': '},{t:'keyword',v:'true'},{t:'bracket',v:' }'},{t:'bracket',v:'),'}],
  [{t:'plain',v:'  '},{t:'func',v:'Attention'},{t:'bracket',v:'('},{t:'bracket',v:'{ '},{t:'variable',v:'heads'},{t:'plain',v:': '},{t:'number',v:'8'},{t:'plain',v:', '},{t:'variable',v:'dim'},{t:'plain',v:': '},{t:'number',v:'32'},{t:'bracket',v:' }'},{t:'bracket',v:'),'}],
  [{t:'plain',v:'  '},{t:'func',v:'Dense'},{t:'bracket',v:'('},{t:'number',v:'3'},{t:'plain',v:', '},{t:'bracket',v:'{ '},{t:'variable',v:'activation'},{t:'plain',v:': '},{t:'string',v:"'softmax'"},{t:'bracket',v:' }'},{t:'bracket',v:')'}],
  [{t:'bracket',v:'])'}],
  [],
  [{t:'comment',v:'// WebSocket price stream'}],
  [{t:'variable',v:'ws'},{t:'plain',v:'.'},{t:'func',v:'on'},{t:'bracket',v:'('},{t:'string',v:"'message'"},{t:'plain',v:', '},{t:'bracket',v:'('},{t:'variable',v:'raw'},{t:'bracket',v:')'},{t:'operator',v:' => '},{t:'bracket',v:'{'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'const '},{t:'bracket',v:'{ '},{t:'variable',v:'price'},{t:'plain',v:', '},{t:'variable',v:'volume'},{t:'plain',v:', '},{t:'variable',v:'ts'},{t:'bracket',v:' }'},{t:'operator',v:' = '},{t:'func',v:'JSON.parse'},{t:'bracket',v:'('},{t:'variable',v:'raw'},{t:'bracket',v:')'}],
  [{t:'plain',v:'  '},{t:'func',v:'orderBook'},{t:'plain',v:'.'},{t:'func',v:'update'},{t:'bracket',v:'('},{t:'variable',v:'price'},{t:'plain',v:', '},{t:'variable',v:'volume'},{t:'bracket',v:')'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'if '},{t:'bracket',v:'('},{t:'func',v:'isAnomaly'},{t:'bracket',v:'('},{t:'variable',v:'price'},{t:'plain',v:', '},{t:'variable',v:'volume'},{t:'bracket',v:')'},{t:'bracket',v:')'},{t:'plain',v:' {'}],
  [{t:'plain',v:'    '},{t:'func',v:'alertEngine'},{t:'plain',v:'.'},{t:'func',v:'trigger'},{t:'bracket',v:'('},{t:'string',v:"'VOLUME_SPIKE'"},{t:'plain',v:', '},{t:'bracket',v:'{ '},{t:'variable',v:'price'},{t:'plain',v:', '},{t:'variable',v:'ts'},{t:'bracket',v:' }'},{t:'bracket',v:')'}],
  [{t:'plain',v:'  }'}],
  [{t:'bracket',v:'})'}],
  [],
  [{t:'comment',v:'// Portfolio optimization — Markowitz mean-variance'}],
  [{t:'keyword',v:'function '},{t:'func',v:'optimize'},{t:'bracket',v:'('},{t:'variable',v:'returns'},{t:'plain',v:', '},{t:'variable',v:'covMatrix'},{t:'bracket',v:')'},{t:'plain',v:' {'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'const '},{t:'variable',v:'n'},{t:'operator',v:' = '},{t:'variable',v:'returns'},{t:'plain',v:'.'},{t:'variable',v:'length'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'let '},{t:'variable',v:'weights'},{t:'operator',v:' = '},{t:'func',v:'Array'},{t:'bracket',v:'('},{t:'variable',v:'n'},{t:'bracket',v:')'},{t:'plain',v:'.'},{t:'func',v:'fill'},{t:'bracket',v:'('},{t:'number',v:'1/n'},{t:'bracket',v:')'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'const '},{t:'variable',v:'target'},{t:'operator',v:' = '},{t:'func',v:'maxSharpe'},{t:'bracket',v:'('},{t:'variable',v:'weights'},{t:'plain',v:', '},{t:'variable',v:'returns'},{t:'plain',v:', '},{t:'variable',v:'covMatrix'},{t:'bracket',v:')'}],
  [{t:'plain',v:'  '},{t:'keyword',v:'return '},{t:'func',v:'solveQP'},{t:'bracket',v:'('},{t:'variable',v:'covMatrix'},{t:'plain',v:', '},{t:'variable',v:'target'},{t:'plain',v:', '},{t:'variable',v:'weights'},{t:'bracket',v:')'}],
  [{t:'plain',v:'}'}],
];

function flattenLine(tokens) {
  const chars = [];
  for (const token of tokens) {
    for (const ch of token.v) {
      chars.push({ ch, color: C[token.t] || C.plain });
    }
  }
  return chars;
}

const flatLines = codeBlocks.map(flattenLine);

const TERMINAL_OUTPUTS = [
  '> Analyzing AAPL... confidence: 0.92',
  '> BUY signal triggered @ $187.42',
  '> Sharpe ratio: 2.31',
  '> Portfolio rebalanced — 12 assets',
  '> SELL EUR/USD — TP: 1.0845',
  '> Backtest: +34.2% annual return',
  '> Risk: 1.8% of capital',
  '> Model accuracy: 89.3%',
  '> Processing 1,247 features...',
  '> LSTM output: [0.87, 0.12, 0.01]',
  '> Stop loss adjusted: $182.10',
  '> Latency: 0.3ms — order filled',
  '> Volatility spike: VIX +12%',
];

const CodeHeroBg = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let W, H, animId, frame = 0;
    const COL_COUNT = 5;

    // Particles
    const particles = [];
    for (let i = 0; i < 50; i++) {
      particles.push({
        x: Math.random(), y: Math.random(),
        vx: (Math.random() - 0.5) * 0.00015,
        vy: -0.00008 - Math.random() * 0.00015,
        char: ['0','1','<','>','{','}','/',';','=','(',')','+','-','*','%','&','|','$'][Math.floor(Math.random() * 18)],
        opacity: 0.03 + Math.random() * 0.06,
        size: 10 + Math.random() * 14,
      });
    }

    // Terminal bubbles
    const terminals = [];
    function spawnTerminal() {
      terminals.push({
        text: TERMINAL_OUTPUTS[Math.floor(Math.random() * TERMINAL_OUTPUTS.length)],
        x: 0.05 + Math.random() * 0.7,
        y: 1.05,
        speed: 0.0004 + Math.random() * 0.0003,
        opacity: 0,
        maxOpacity: 0.2 + Math.random() * 0.15,
        age: 0,
        life: 400 + Math.random() * 300,
      });
    }

    // Columns
    const columns = [];

    function initColumns() {
      columns.length = 0;
      const colW = W / COL_COUNT;
      for (let i = 0; i < COL_COUNT; i++) {
        const startLine = Math.floor(Math.random() * flatLines.length);
        const scale = 0.75 + Math.random() * 0.3;
        const lineH = Math.round(20 * scale);
        columns.push({
          x: colW * i + 16,
          width: colW - 20,
          opacity: 0.15 + Math.random() * 0.2,
          scale,
          currentLine: startLine,
          charIndex: 0,
          typedLines: [],
          maxVisibleLines: Math.floor(H / lineH) - 1,
          typeSpeed: 1 + Math.floor(Math.random() * 2),
          pauseTimer: 0,
          lineCounter: startLine + 1,
        });
      }
    }

    function drawGrid() {
      ctx.strokeStyle = 'rgba(99, 102, 241, 0.025)';
      ctx.lineWidth = 1;
      const sp = 60;
      for (let x = 0; x < W; x += sp) {
        ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke();
      }
      for (let y = 0; y < H; y += sp) {
        ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke();
      }
    }

    function drawChar(ch, color, x, y, fontSize, alpha) {
      ctx.font = `${fontSize}px 'SF Mono','Fira Code','Consolas',monospace`;
      ctx.fillStyle = color;
      ctx.globalAlpha = alpha;
      ctx.fillText(ch, x, y);
      return ctx.measureText(ch).width;
    }

    function drawCursor(x, y, fontSize, alpha) {
      const blink = Math.sin(frame * 0.08);
      if (blink > -0.2) {
        ctx.fillStyle = '#528bff';
        ctx.globalAlpha = alpha * (0.5 + blink * 0.3);
        ctx.fillRect(x, y - fontSize + 3, fontSize * 0.52, fontSize);
        ctx.globalAlpha = 1;
      }
    }

    function resize() {
      const dpr = window.devicePixelRatio || 1;
      const parent = canvas.parentElement;
      if (!parent) return;
      W = parent.clientWidth;
      H = parent.clientHeight;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      initColumns();
    }

    function render() {
      frame++;
      ctx.clearRect(0, 0, W, H);

      drawGrid();

      // Floating particles
      for (const p of particles) {
        p.x += p.vx; p.y += p.vy;
        if (p.y < -0.05) { p.y = 1.05; p.x = Math.random(); }
        if (p.x < -0.05) p.x = 1.05;
        if (p.x > 1.05) p.x = -0.05;
        ctx.font = `${p.size}px 'SF Mono',monospace`;
        ctx.fillStyle = '#6366f1';
        ctx.globalAlpha = p.opacity;
        ctx.fillText(p.char, p.x * W, p.y * H);
      }
      ctx.globalAlpha = 1;

      // Code columns
      for (const col of columns) {
        const fontSize = Math.round(13 * col.scale);
        const lineH = Math.round(20 * col.scale);
        const lineNumW = Math.round(40 * col.scale);

        if (col.pauseTimer > 0) {
          col.pauseTimer--;
        } else {
          const line = flatLines[col.currentLine % flatLines.length];
          if (line.length === 0) {
            col.typedLines.push({ chars: [], lineNum: col.lineCounter });
            col.lineCounter++;
            col.currentLine++;
            col.charIndex = 0;
            col.pauseTimer = 8 + Math.floor(Math.random() * 10);
          } else {
            for (let s = 0; s < col.typeSpeed; s++) {
              if (col.charIndex < line.length) col.charIndex++;
            }
            if (col.charIndex >= line.length) {
              col.typedLines.push({ chars: [...line], lineNum: col.lineCounter });
              col.lineCounter++;
              col.currentLine++;
              col.charIndex = 0;
              const isComment = codeBlocks[col.currentLine % codeBlocks.length].length > 0 &&
                codeBlocks[col.currentLine % codeBlocks.length][0].t === 'comment';
              col.pauseTimer = isComment ? 25 + Math.random() * 15 : 6 + Math.floor(Math.random() * 8);
            }
          }
        }

        while (col.typedLines.length > col.maxVisibleLines) col.typedLines.shift();

        for (let i = 0; i < col.typedLines.length; i++) {
          const tl = col.typedLines[i];
          const y = lineH + i * lineH;
          const ageFade = 0.5 + 0.5 * (i / col.typedLines.length);
          const alpha = col.opacity * ageFade;
          ctx.font = `${fontSize}px 'SF Mono','Fira Code','Consolas',monospace`;
          ctx.fillStyle = C.comment;
          ctx.globalAlpha = alpha * 0.4;
          ctx.fillText(String(tl.lineNum % 100).padStart(3, ' '), col.x, y);
          let cx = col.x + lineNumW;
          for (const c of tl.chars) cx += drawChar(c.ch, c.color, cx, y, fontSize, alpha);
        }

        const currentY = lineH + col.typedLines.length * lineH;
        const curLine = flatLines[col.currentLine % flatLines.length];
        const curLineNum = col.lineCounter;
        ctx.font = `${fontSize}px 'SF Mono','Fira Code','Consolas',monospace`;
        ctx.fillStyle = C.comment;
        ctx.globalAlpha = col.opacity * 0.4;
        ctx.fillText(String(curLineNum % 100).padStart(3, ' '), col.x, currentY);
        let cx = col.x + lineNumW;
        for (let j = 0; j < col.charIndex && j < curLine.length; j++) {
          const c = curLine[j];
          const freshness = j > col.charIndex - 4 ? 1.4 : 1;
          cx += drawChar(c.ch, c.color, cx, currentY, fontSize, Math.min(1, col.opacity * freshness));
        }
        drawCursor(cx, currentY, fontSize, col.opacity * 1.2);
        ctx.globalAlpha = 1;
      }

      // Terminal bubbles
      for (let i = terminals.length - 1; i >= 0; i--) {
        const t = terminals[i];
        t.y -= t.speed;
        t.age++;
        if (t.age < 40) t.opacity = (t.age / 40) * t.maxOpacity;
        else if (t.age > t.life - 60) t.opacity = ((t.life - t.age) / 60) * t.maxOpacity;
        else t.opacity = t.maxOpacity;
        if (t.age > t.life) { terminals.splice(i, 1); continue; }

        const tx = t.x * W, ty = t.y * H;
        ctx.font = '12px "SF Mono","Fira Code",monospace';
        const tw = ctx.measureText(t.text).width;
        const pad = 8, r = 4;
        ctx.fillStyle = '#0f172a';
        ctx.globalAlpha = t.opacity * 0.8;
        ctx.beginPath();
        ctx.roundRect(tx - pad, ty - 14 - pad / 2, tw + pad * 2, 20 + pad, r);
        ctx.fill();
        ctx.strokeStyle = '#6366f1';
        ctx.globalAlpha = t.opacity * 0.35;
        ctx.lineWidth = 1;
        ctx.stroke();
        const green = t.text.includes('BUY') || t.text.includes('+') || t.text.includes('accuracy');
        const red = t.text.includes('SELL') || t.text.includes('spike') || t.text.includes('Stop');
        ctx.fillStyle = green ? '#00FF94' : red ? '#EF4444' : '#61afef';
        ctx.globalAlpha = t.opacity;
        ctx.fillText(t.text, tx, ty);
      }
      ctx.globalAlpha = 1;

      // Scan line
      const scanY = (frame * 0.4) % H;
      const sg = ctx.createLinearGradient(0, scanY - 40, 0, scanY + 40);
      sg.addColorStop(0, 'rgba(99,102,241,0)');
      sg.addColorStop(0.5, 'rgba(99,102,241,0.018)');
      sg.addColorStop(1, 'rgba(99,102,241,0)');
      ctx.fillStyle = sg;
      ctx.fillRect(0, scanY - 40, W, 80);

      // Vignette
      const vig = ctx.createRadialGradient(W / 2, H / 2, H * 0.3, W / 2, H / 2, H * 0.9);
      vig.addColorStop(0, 'rgba(0,0,0,0)');
      vig.addColorStop(1, 'rgba(0,0,0,0.5)');
      ctx.fillStyle = vig;
      ctx.fillRect(0, 0, W, H);

      if (frame % 140 === 0) spawnTerminal();

      animId = requestAnimationFrame(render);
    }

    resize();
    render();
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}
    />
  );
};

export default CodeHeroBg;
